import React from 'react';
import { HStack } from 'native-base';

export default function Row(props) {
  return <HStack space={3} justifyContent="center" {...props}>
    {props.children}
  </HStack>;
};
